type DeepPartial<T> = {
    [P in keyof T]?: DeepPartial<T[P]>;
};

export const isDefinedUnknownObject = <T>(value: unknown): value is DeepPartial<T> =>
    typeof value === "object" && value !== null;

export const isDefinedObject = <T extends object>(value: T | undefined | null): value is T =>
    isDefinedUnknownObject(value);
